export default function FAQuestionContent(props: any) {
  return (
    <div className="text-left mt-3 mb-6 text-gray-800 text-lg">{props.children}</div>
  );
}
